export default "__VITE_ASSET__nmf9gCeA__"